export const hv_tco_data = [
  {
    make: 'Diesel',
    model: '3.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 3.5 - 4.5t Rigid',
    gvm: 3500,
    payload: 1565,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max: 0,
    battery: 70,
    range: 350,
    efficiency: 0.2,
    Charging: 0,
    charge_time: 0,
    battery_warranty: 0,
    chassis_cost: '50000',
    service_cost_km: 0.31,
    tyre_cost_km: 0.03,
    id: 1,
  },
  {
    make: 'Diesel',
    model: '4.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 3.5 - 4.5t Rigid',
    gvm: 4500,
    payload: 1900,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max: 0,
    battery: 100,
    range: 323,
    efficiency: 0.31,
    Charging: 0,
    charge_time: 0,
    battery_warranty: 0,
    chassis_cost: '70000',
    service_cost_km: 0.31,
    tyre_cost_km: 0.03,
    id: 2,
  },
  {
    make: 'Diesel',
    model: '8t vehicle',
    heavy_vehicle_weight_class: 'GVM 4.5- 8t Rigid',
    gvm: 8000,
    payload: 4900,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max: 187,
    battery: 200,
    range: 833,
    efficiency: 0.24,
    Charging: 0,
    charge_time: 0,
    battery_warranty: 0,
    chassis_cost: '80000',
    service_cost_km: 0.39,
    tyre_cost_km: 0.03,
    id: 3,
  },
  {
    make: 'Diesel',
    model: '6.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 4.5- 8t Rigid',
    gvm: 6500,
    payload: 4500,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max: 0,
    battery: 100,
    range: 400,
    efficiency: 0.28,
    Charging: 0,
    charge_time: 0,
    battery_warranty: 0,
    chassis_cost: '70000',
    service_cost_km: 0.31,
    tyre_cost_km: 0.03,
    id: 10,
  },
  {
    make: 'Diesel',
    model: '8.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 8 - 15t Rigid',
    gvm: 8500,
    payload: 5600,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max: 187,
    battery: 200,
    range: 606,
    efficiency: 0.33,
    Charging: 0,
    charge_time: 0,
    battery_warranty: 0,
    chassis_cost: '100000',
    service_cost_km: 0.39,
    tyre_cost_km: 0.03,
    id: 4,
  },
  {
    make: 'Diesel',
    model: '16t vehicle',
    heavy_vehicle_weight_class: 'GVM over 15t Rigid',
    gvm: 16000,
    payload: 6000,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max: 187,
    battery: 300,
    range: 909,
    efficiency: 0.33,
    Charging: 0,
    charge_time: 0,
    battery_warranty: 0,
    chassis_cost: '130000',
    service_cost_km: 0.42,
    tyre_cost_km: 0.05,
    id: 5,
  },
  {
    make: 'Diesel',
    model: '26t vehicle',
    heavy_vehicle_weight_class: 'GVM over 15t Rigid',
    gvm: 26000,
    payload: 10000,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max: 187,
    battery: 300,
    range: 909,
    efficiency: 0.33,
    Charging: 0,
    charge_time: 0,
    battery_warranty: 0,
    chassis_cost: '170000',
    service_cost_km: 0.49,
    tyre_cost_km: 0.07,
    id: 6,
  },
  {
    make: 'Diesel',
    model: 'Prime mover',
    heavy_vehicle_weight_class: 'Prime Mover',
    gvm: 34000,
    payload: 30000,
    passenger_max_for_comparison: 0,
    fuel_type: 'Diesel',
    power_max: 0,
    battery: 300,
    range: 775,
    efficiency: 0.387,
    Charging: 0,
    charge_time: 0,
    battery_warranty: 0,
    chassis_cost: '270000',
    service_cost_km: 0.6,
    tyre_cost_km: 0.2,
    id: 7,
  },
  {
    make: 'BEV',
    model: '4.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 3.5 - 4.5t Rigid',
    gvm: 4500,
    payload: 1989,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 127,
    battery: 88,
    range: 300,
    efficiency: 0.2933,
    Charging: 22,
    charge_time: 300,
    battery_warranty: 0,
    chassis_cost: '144392',
    service_cost_km: 0.22,
    tyre_cost_km: 0.03,
    id: 8,
  },
  {
    make: 'BEV',
    model: '4.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 3.5 - 4.5t Rigid',
    gvm: 4500,
    payload: 1500,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 150,
    battery: 81,
    range: 260,
    efficiency: 0.29,
    Charging: 22,
    charge_time: 300,
    battery_warranty: 0,
    chassis_cost: '144392',
    service_cost_km: 0.22,
    tyre_cost_km: 0.03,
    id: 9,
  },
  {
    make: 'BEV',
    model: '6.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 4.5- 8t Rigid',
    gvm: 6500,
    payload: 3494,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 108,
    battery: 100,
    range: 250,
    efficiency: 0.4,
    Charging: 22,
    charge_time: 360,
    battery_warranty: 0,
    chassis_cost: '153346',
    service_cost_km: 0.31,
    tyre_cost_km: 0.03,
    id: 11,
  },
  {
    make: 'BEV',
    model: '8t vehicle',
    heavy_vehicle_weight_class: 'GVM 4.5- 8t Rigid',
    gvm: 7995,
    payload: 4933,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 125,
    battery: 100,
    range: 250,
    efficiency: 0.4,
    Charging: 22,
    charge_time: 360,
    battery_warranty: 0,
    chassis_cost: '158146',
    service_cost_km: 0.31,
    tyre_cost_km: 0.03,
    id: 13,
  },
  {
    make: 'BEV',
    model: '8t vehicle',
    heavy_vehicle_weight_class: 'GVM 4.5- 8t Rigid',
    gvm: 7995,
    payload: 4574,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 125,
    battery: 138,
    range: 300,
    efficiency: 0.46,
    Charging: 22,
    charge_time: 420,
    battery_warranty: 0,
    chassis_cost: '187720',
    service_cost_km: 0.31,
    tyre_cost_km: 0.03,
    id: 15,
  },
  {
    make: 'BEV',
    model: '8.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 8 - 15t Rigid',
    gvm: 8500,
    payload: 5438,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 125,
    battery: 100,
    range: 250,
    efficiency: 0.4,
    Charging: 22,
    charge_time: 360,
    battery_warranty: 0,
    chassis_cost: '158146',
    service_cost_km: 0.31,
    tyre_cost_km: 0.03,
    id: 16,
  },
  {
    make: 'BEV',
    model: '8.5t vehicle',
    heavy_vehicle_weight_class: 'GVM 8 - 15t Rigid',
    gvm: 8500,
    payload: 5079,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 125,
    battery: 138,
    range: 300,
    efficiency: 0.46,
    Charging: 22,
    charge_time: 420,
    battery_warranty: 0,
    chassis_cost: '187720',
    service_cost_km: 0.31,
    tyre_cost_km: 0.03,
    id: 18,
  },
  {
    make: 'BEV',
    model: '16.5t vehicle',
    heavy_vehicle_weight_class: 'GVM over 15t Rigid',
    gvm: 16500,
    payload: 10200,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 350,
    battery: 138,
    range: 200,
    efficiency: 0.69,
    Charging: 22,
    charge_time: 420,
    battery_warranty: 0,
    chassis_cost: '259084',
    service_cost_km: 0.33,
    tyre_cost_km: 0.05,
    id: 20,
  },
  {
    make: 'BEV',
    model: '16.5t vehicle',
    heavy_vehicle_weight_class: 'GVM over 15t Rigid',
    gvm: 16500,
    payload: 9600,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 350,
    battery: 220,
    range: 250,
    efficiency: 0.88,
    Charging: 22,
    charge_time: 660,
    battery_warranty: 0,
    chassis_cost: '315083',
    service_cost_km: 0.33,
    tyre_cost_km: 0.05,
    id: 21,
  },
  {
    make: 'BEV',
    model: '19.0t vehicle',
    heavy_vehicle_weight_class: 'GVM over 15t Rigid',
    gvm: 19000,
    payload: 7000,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 225,
    battery: 265,
    range: 220,
    efficiency: 0.85,
    Charging: 22,
    charge_time: 780,
    battery_warranty: 0,
    chassis_cost: '400000',
    service_cost_km: 0.42,
    tyre_cost_km: 0.07,
    id: 23,
  },
  {
    make: 'BEV',
    model: '22.5t vehicle',
    heavy_vehicle_weight_class: 'GVM over 15t Rigid',
    gvm: 22500,
    payload: 14300,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 372,
    battery: 280,
    range: 300,
    efficiency: 0.9333,
    Charging: 22,
    charge_time: 840,
    battery_warranty: 0,
    chassis_cost: '380373',
    service_cost_km: 0.42,
    tyre_cost_km: 0.07,
    id: 22,
  },
  {
    make: 'BEV',
    model: 'Prime mover',
    heavy_vehicle_weight_class: 'Prime Mover',
    gvm: 34000,
    payload: 28000,
    passenger_max_for_comparison: 0,
    fuel_type: 'Electric',
    power_max: 380,
    battery: 620,
    range: 310,
    efficiency: 1.2,
    Charging: 22,
    charge_time: 1740,
    battery_warranty: 0,
    chassis_cost: '500000',
    service_cost_km: 0.45,
    tyre_cost_km: 0.2,
    id: 24,
  },
]
export const vehicle_models = [
  {
    make_model: 'Hino 300 (Dutro) Z-EV',
    gvm: 3490,
    payload: 1000,
    capacity: 40,
    range: 150,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'LD',
  },
  {
    make_model: 'Farizon H9E 4.5T SWB',
    gvm: 4495,
    payload: 1997,
    capacity: 100,
    range: 360,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'SEA Electric 300-45 70-7',
    gvm: 4500,
    payload: 1989,
    capacity: 88,
    range: 300,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'Hyundai Mighty Electric 4.5T',
    gvm: 4500,
    payload: 1250,
    capacity: 114.5,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Foton T5',
    gvm: 4500,
    payload: 1500,
    capacity: 81,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Fuso eCanter E515',
    gvm: 4500,
    payload: 1755,
    capacity: 41,
    range: 100,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Sitrak C3HE 4.5T',
    gvm: 4500,
    payload: 2000,
    capacity: 86,
    range: 220,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'SANY FR601 NB1',
    gvm: 4500,
    payload: 2110,
    capacity: 84,
    range: 240,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'LD',
  },
  {
    make_model: 'Isuzu NLR 45-150 EV',
    gvm: 4500,
    payload: 'TBC',
    capacity: 60,
    range: 150,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'LD',
  },
  {
    make_model: 'BYD T45',
    gvm: 4500,
    payload: 2725,
    capacity: 62,
    range: 200,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'LD',
  },
  {
    make_model: 'VIA Motors Cab Chassis Class 2',
    gvm: 4530,
    payload: 2000,
    capacity: '<165',
    range: 400,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'JAC N55 EV',
    gvm: 5500,
    payload: 2000,
    capacity: 96.7,
    range: 220,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'VIA Motors Cab Chassis Class 3',
    gvm: 5670,
    payload: 3000,
    capacity: '<165',
    range: 390,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'Fuso eCanter E615',
    gvm: 6000,
    payload: 3255,
    capacity: 83,
    range: 100,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Sitrak C3HE 6T',
    gvm: 6000,
    payload: 3275,
    capacity: 100,
    range: 250,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Foton T5',
    gvm: 6000,
    payload: 3000,
    capacity: 81,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'SANY FR601 NB2',
    gvm: 6000,
    payload: 3610,
    capacity: 84,
    range: 240,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'LD',
  },
  {
    make_model: 'DFAC Captain 45e',
    gvm: 4500,
    payload: 'TBC',
    capacity: 'TBC',
    range: 'TBC',
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'LD',
  },
  {
    make_model: 'SEA Electric 300-85 100-10',
    gvm: 6500,
    payload: 3494,
    capacity: 100,
    range: 240,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'Iveco eDaily',
    gvm: 7200,
    payload: 4300,
    capacity: 111,
    range: 180,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'LD',
  },
  {
    make_model: 'Zeus Z-19',
    gvm: 7250,
    payload: 2750,
    capacity: 175,
    range: 320,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'Hyundai Mighty Electric 7.3T',
    gvm: 7300,
    payload: 4050,
    capacity: 114.5,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Fuso eCanter (1st gen)',
    gvm: 7490,
    payload: 4220,
    capacity: 81,
    range: 100,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'JAC N75 EV',
    gvm: 7490,
    payload: 4100,
    capacity: 107,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Fuso eCanter E818',
    gvm: 7500,
    payload: 4250,
    capacity: 83,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Isuzu NPR 75-200 EV',
    gvm: 7500,
    payload: 'TBC',
    capacity: 100,
    range: '200',
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'LD',
  },
  {
    make_model: 'SEA Electric 300-85 100-15',
    gvm: 7995,
    payload: 4933,
    capacity: 100,
    range: 240,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'SEA Electric 300-85 120-15',
    gvm: 7995,
    payload: 4574,
    capacity: 138,
    range: 300,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'Farizon H9E 8T SWB',
    gvm: 7995,
    payload: 4615,
    capacity: 107,
    range: 232,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Farizon H9E 8T LWB',
    gvm: 7995,
    payload: 4085,
    capacity: 162,
    range: 352,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Nu Nxu XT',
    gvm: 8000,
    payload: 'TBC',
    capacity: 'TBC',
    range: 'TBC',
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'HDrive T8-H80 Cargo',
    gvm_end_value: '*',
    gvm: '8000',
    payload: 'TBC',
    capacity: '30 kWh battery\n82 kW fuel cell',
    range: 'TBC',
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'LD',
  },
  {
    make_model: 'Zeus Z-19',
    gvm: 8100,
    payload: 3600,
    capacity: 210,
    range: 320,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'Zeus Z-22',
    gvm: 8100,
    payload: 5000,
    capacity: 175,
    range: 320,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'Foton eAUMARK S',
    gvm: 8500,
    payload: 'TBC',
    capacity: 100,
    range: 'TBC',
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'LD',
  },
  {
    make_model: 'SEA Electric 300-85 100-15',
    gvm: 8500,
    payload: 5438,
    capacity: 100,
    range: 240,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'SEA Electric 300-85 120-15',
    gvm: 8500,
    payload: 5079,
    capacity: 138,
    range: 305,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'LD',
  },
  {
    make_model: 'Fuso eCanter E918',
    gvm: 8550,
    payload: 4990,
    capacity: 83,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'Fuso eCanter E918 Long Range',
    gvm: 8550,
    payload: 4575,
    capacity: 124,
    range: 300,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'LD',
  },
  {
    make_model: 'JAC N90 EV',
    gvm: 9000,
    payload: 5000,
    capacity: 107,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'MD',
  },
  {
    make_model: 'DFAC Captain 85e',
    gvm: 8500,
    payload: 'TBC',
    capacity: 'TBC',
    range: 'TBC',
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'MD',
  },
  {
    make_model: 'Zeus Z-22',
    gvm: 10100,
    payload: 5000,
    capacity: 210,
    range: 320,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'MD',
  },
  {
    make_model: 'Volvo FL Electric 14T',
    gvm: 14000,
    payload: 'TBC',
    capacity: 145,
    range: 200,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'MD',
  },
  {
    make_model: 'SEA Electric 500-140 120-35',
    gvm: 14000,
    payload: 9360,
    capacity: 138,
    range: 200,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'MD',
  },
  {
    make_model: 'HDrive T15-H100',
    gvm: 15000,
    payload: 'TBC',
    capacity: '74 kWh battery\n110 kW fuel cell',
    range: 620,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'MD',
  },
  {
    make_model: 'Volvo FL Electric Rigid',
    gvm: 16000,
    payload: 8120,
    capacity: 375,
    range: 450,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'MD',
  },
  {
    make_model: 'SEA Electric 500-160 120-35',
    gvm: 16000,
    payload: 9700,
    capacity: 138,
    range: 200,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'MD',
  },
  {
    make_model: 'SEA Electric 500-160 180-35',
    gvm: 16000,
    payload: 9100,
    capacity: 220,
    range: 250,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'MD',
  },
  {
    make_model: 'Scania 25P',
    gvm: 16000,
    payload: 7100,
    capacity: 300,
    range: 250,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'MD',
  },
  {
    make_model: 'Deepway Star 4x2',
    gvm: 16000,
    payload: 'TBC',
    capacity: 600,
    range: 500,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'MD',
  },
  {
    make_model: 'Foton eAUMAN D',
    gvm: 18000,
    payload: 'TBC',
    capacity: 281,
    range: 'TBC',
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'MD',
  },
  {
    make_model: 'HDrive TS18-110',
    gvm_end_value: '*',
    gvm: '18000',
    payload: 'TBC',
    capacity: '74 kWh battery\n110 kW fuel cell',
    range: 450,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'MD',
  },
  {
    make_model: 'DAF XB Electric',
    gvm: 19000,
    payload: 'TBC',
    capacity: 282,
    range: 350,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'MD',
  },
  {
    make_model: 'Mercedes-Benz eActros 300',
    gvm: 19000,
    payload: 10600,
    capacity: 336,
    range: 330,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'MD',
  },
  {
    make_model: 'DAF LF Electric',
    gvm: 19000,
    payload: 11700,
    capacity: 282,
    range: 280,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'MD',
  },
  {
    make_model: 'Volvo FE Electric Rigid',
    gvm: 21000,
    payload: 7495,
    capacity: 375,
    range: 300,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'MD',
  },
  {
    make_model: 'SEA Electric 500-225 250-62',
    gvm: 22500,
    payload: 14300,
    capacity: 248,
    range: 240,
    type: 'Electric',
    availability: 'Discontinued',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive T23-H160',
    gvm: 23000,
    payload: 'TBC',
    capacity: '74 kWh battery\n160 kW fuel cell',
    range: 450,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive T23-H200',
    gvm: 23000,
    payload: 'TBC',
    capacity: '74 kWh battery\n200 kW fuel cell',
    range: 450,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive TG23-H160 Refuse',
    gvm: 23000,
    payload: 'TBC',
    capacity: '74kWh battery\n160 kW fuel cell',
    range: 250,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive TG23-H220 Refuse',
    gvm: 23000,
    payload: 'TBC',
    capacity: '74 kWh battery\n220 kW fuel cell',
    range: 250,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Pure Hydrogen Waste Truck',
    gvm: 23000,
    payload: 'TBC',
    capacity: 'TBC',
    range: 300,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive TG23-H160 Refueller',
    gvm: 23000,
    payload: 'TBC',
    capacity: '74 kWh battery\n160 kW fuel cell',
    range: 300,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive TH23-H200 Refueller',
    gvm: 23000,
    payload: 'TBC',
    capacity: '74 kWh battery\n200 kW fuel cell',
    range: 300,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Deepway Star 6x4',
    gvm: 23500,
    payload: 'TBC',
    capacity: 600,
    range: 'TBC',
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'SANY SYG3',
    gvm: 25000,
    payload: 11800,
    capacity: 588,
    range: 'TBC',
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'Sitrak C9H EV',
    gvm: 25000,
    payload: 'TBC',
    capacity: 600,
    range: 380,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Sitrak TX 6x4',
    gvm: 25000,
    payload: 19600,
    capacity: 422,
    range: 250,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'BYD M25',
    gvm: 25000,
    payload: 'TBC',
    capacity: 452,
    range: 300,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'Zeron Jingzhe',
    gvm: 25000,
    payload: 'TBC',
    capacity: 600,
    range: 400,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Hyzon Rigid 6x4',
    gvm: 26000,
    payload: 14360,
    capacity: '55 kWh battery\n25 kg H2',
    range: 250,
    type: 'Fuel cell',
    availability: 'Discontinued',
    Duty: 'HD',
  },
  {
    make_model: 'Mercedes-Benz eActros 400',
    gvm: 27000,
    payload: 16600,
    capacity: 448,
    range: 400,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Mercedes-Benz eEconic',
    gvm: 27000,
    payload: 17800,
    capacity: 336,
    range: 150,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FE Electric Rigid',
    gvm: 27000,
    payload: 13785,
    capacity: 375,
    range: 300,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Windrose E700',
    gvm: 27000,
    payload: 14850,
    capacity: 729,
    range: 670,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'Hyundai XCIENT',
    gvm: 27000,
    payload: 'TBC',
    capacity: '72 kWh battery\n31 kg H2',
    range: 400,
    type: 'Fuel cell',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'BYD T28',
    gvm: 28000,
    payload: 17350,
    capacity: 301,
    range: 300,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive T28-H220',
    gvm: 28000,
    payload: 'TBC',
    capacity: '74 kWh battery\n220 kW fuel cell',
    range: 400,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FH Electric Rigid',
    gvm: 29000,
    payload: 10735,
    capacity: 540,
    range: 400,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FM Electric Rigid',
    gvm: 29000,
    payload: 12705,
    capacity: 540,
    range: 400,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FMX Electric Rigid',
    gvm: 29000,
    payload: 12660,
    capacity: 540,
    range: 400,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FH Electric Tractor',
    gvm: 29000,
    payload: 12985,
    capacity: 540,
    range: 400,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FH Aero Electric Tractor',
    gvm: 29000,
    payload: 'TBC',
    capacity: 540,
    range: 400,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FM Electric Tractor',
    gvm: 29000,
    payload: 12985,
    capacity: 540,
    range: 400,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FMX Electric Tractor',
    gvm: 29000,
    payload: 12875,
    capacity: 540,
    range: 400,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'DAF XD Electric',
    gvm: 29000,
    payload: 'TBC',
    capacity: 525,
    range: 500,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'DAF XF Electric',
    gvm: 29000,
    payload: 'TBC',
    capacity: 525,
    range: 500,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Foton eAUMAN C (concrete mixer truck)',
    gvm: 31000,
    payload: 'TBC',
    capacity: 282,
    range: 'TBC',
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Sitrak TX 8x4',
    gvm: 31000,
    payload: 17290,
    capacity: 422,
    range: 250,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'SANY eMixer SY408P (concrete mixer truck)',
    gvm: 32000,
    payload: 'TBC',
    capacity: 350,
    range: 150,
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
    {
    make_model: 'SANY EV Dump Truck',
    gvm: 'TBC',
    payload: 'TBC',
    capacity: 'TBC',
    range: 'TBC',
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'BYD T31',
    gvm: 60000,
    payload: 43770,
    capacity: 471,
    range: 250,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive Taurus TS42-200',
    gvm_end_value: '*',
    gvm: '42000',
    payload: 'TBC',
    capacity: '58 kWh battery\n200 kW fuel cell',
    range: 600,
    type: 'Fuel cell',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Mercedes-Benz eActros 600',
    gvm_end_value: '*',
    gvm: '44000',
    payload: 'TBC',
    capacity: 621,
    range: 500,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Volvo FH Aero Electric (next gen)',
    gvm_end_value: '*',
    gvm: '48000',
    payload: 'TBC',
    capacity: 780,
    range: 700,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive Taurus TS50-200',
    gvm_end_value: '*',
    gvm: '50000',
    payload: 'TBC',
    capacity: '58 kWh battery\n200 kW fuel cell',
    range: 500,
    type: 'Fuel cell',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'KRW Hydron Quantum H53',
    gvm_end_value: '*',
    gvm: '53000',
    payload: 'TBC',
    capacity: '117.46 kWh battery\n73 kg H2',
    range: 600,
    type: 'Fuel cell',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
  {
    make_model: 'Scania BEV Prime Mover',
    gvm_end_value: '*',
    gvm: '64000',
    payload: 'TBC',
    capacity: 728,
    range: 720,
    type: 'Electric',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Hyzon HYHD8-200',
    gvm: 'TBC',
    payload: 'TBC',
    capacity: 'TBC kWh battery\n50 kg H2',
    range: 'TBC',
    type: 'Fuel cell',
    availability: 'Discontinued',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive HP70-400',
    gvm_end_value: '*',
    gvm: '68000',
    payload: 'TBC',
    capacity: '74 kWh battery\n440 kW fuel cell',
    range: 500,
    type: 'Fuel cell',
    availability: 'Potential future model',
    Duty: 'HD',
  },
  {
    make_model: 'Janus (retrofit model)',
    gvm_start_value: 'up to',
    gvm_end_value: '*',
    gvm: '70000',
    payload: 'Depends on retrofit vehicle',
    capacity: 620,
    capacity_start_value: 'up to',
    range: '200-400',
    type: 'Electric',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'HDrive Taurus TS70-300',
    gvm_end_value: '*',
    gvm: '70000',
    payload: 'TBC',
    capacity: '58 kWh battery\n310 kW fuel cell',
    range: 500,
    type: 'Fuel cell',
    availability: 'Available now',
    Duty: 'HD',
  },
  {
    make_model: 'Pure One Alpha',
    gvm_end_value: '*',
    gvm: '90000',
    payload: 'TBC',
    capacity: 400,
    range: 300,
    type: 'Electric',
    availability: 'Confirmed future model',
    Duty: 'HD',
  },
]